import ISO6391 from 'iso-639-1';

/**
 *  @file src/utils/translationLanguages.js
 *  @description Support for translation language pairs.
 */

export default class TranslationLanguages {

    /**
     *  @constructor
     *  @param {array} languages - Array of language pairs the user has permission for
     */
    constructor(languages=null) {
        this._languages = [];
        if (languages) {
            this.__init(languages);
        }
    }

    /**
     * @function __init
     * @description Initialize the internal language structure
     * @param {array} languages - Array of language pairs the user has permission for
     */
    __init(languages) {
        if (languages) {
            var lng = {
                auto: []
            };
            languages.forEach((l) => {
                var parts = l.split('-');
                if (parts && parts.length == 2) {
                    var src = parts[0];
                    var dst = parts[1];
                    if (!(src in lng)) {
                        lng[src] = [];
                    }
                    lng[src].push(dst);
                    if (!lng['auto'].includes(dst)) {
                        lng['auto'].push(dst);
                    }
                }
            })
            this._languages = lng;
        }
    }

    /**
     * @function load
     * @description Load the object with the given language pairs
     * @param {array} languages - Array of language pairs the user has permission for
     */
    load(languages) {
        if (languages) {
            this.__init(languages);
        }
    }

    /**
     * @function getSourceLanguages
     * @description Return an array of source languages the user has permissions for
     * @returns {array} - Array of language objects in form { code, name }
     */
    getSourceLanguages() {
        if (this._languages) {
            var lngs = [];
            Object.keys(this._languages).forEach((key) => {
                if (key == 'auto') {
                    lngs.push({ code: key, name: key })
                } else {
                    lngs.push({ code: key, name: ISO6391.getName(key) })
                }
            })
            return lngs;
        }
        return [];
    }

    /**
     * @function getTargetLanguages
     * @description Return an array of target languages for the give source language code
     * @returns {array} - Array of language objects in form { code, name }
     */
    getTargetLanguages(code) {
        if (code && this._languages) {
            if (Object.keys(this._languages).includes(code)) {
                var lngs = [];
                this._languages[code].forEach((lng) => {
                    lngs.push({ code: lng, name: ISO6391.getName(lng)})
                })
                return lngs;
            }
        }
        return [];
    }
}
